import { render, staticRenderFns } from "./soldout-button.vue?vue&type=template&id=678b6056&scoped=true&"
import script from "./soldout-button.vue?vue&type=script&lang=js&"
export * from "./soldout-button.vue?vue&type=script&lang=js&"
import style0 from "./soldout-button.vue?vue&type=style&index=0&id=678b6056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b6056",
  null
  
)

export default component.exports